import React from 'react';

const CalendarIcon = ({color = `#545454` }) => {
  return(
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.756 2.59961H2.55519C1.67147 2.59961 0.955078 3.316 0.955078 4.19972V15.4005C0.955078 16.2842 1.67147 17.0006 2.55519 17.0006H13.756C14.6397 17.0006 15.3561 16.2842 15.3561 15.4005V4.19972C15.3561 3.316 14.6397 2.59961 13.756 2.59961Z" stroke="#545454" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.3574 1V4.20022" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.95508 1V4.20022" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M0.955078 7.40039H15.3561" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default CalendarIcon;
